import { EmpresaGrupoStruct } from "../../structs/usuario/empresa-grupo.struct";

export class EmpresaGrupoRequest {
    empresaGrupo: EmpresaGrupoStruct;
}